import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-priority_export",
  "use": "icon-priority_export-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-priority_export\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12.7,12.67v2.66H11.3V12.67H9.2L12,10l2.8,2.67ZM6.4,7.33v9.34H17.6v-8H11.71l-1.4-1.34Zm5.89,0h6A.68.68,0,0,1,19,8v9.33a.68.68,0,0,1-.7.67H5.7a.68.68,0,0,1-.7-.67V6.67A.68.68,0,0,1,5.7,6h5.19Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol